import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output } from '@angular/core';
import { AppConfigService } from '../reactive-forms/services/app-config.service';
import { CryptService } from '../shared/services/crypt.service';
import { SBHttpServicesService } from '../shared/services/sbhttp-services.service';
import { HttpService } from '../shared/services/HttpClientServices/Http.service';
import { SalesBuzzParams } from '../shared/Enums/SalesOrderParams';
import { TranslateService } from '@ngx-translate/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { LoginInputModel } from '../login/LoginInputModel';
import { LoginService } from '../login/login.service';
import { AuthTypeEnum } from '../login/login.component';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['../login/login.component.scss']
})
export class LoginFormComponent {
  @Output() LoginEvent = new EventEmitter();

  public showPassword: boolean;
  public Displayedpassword: string;
  public defaultAuth: any;
  public username: string;
  public password: string;
  public listItems: any;
  public imagePath: string;
  public creds: LoginInputModel;
  public UserNameErrorMSg: string;
  public passwordErrorMSg: string;
  @Input() loginErrorMsgName: string;
  public AuthTypeItems: Array<{ text: string, value: number }> = [];
  SSOLoginUrl: string;
  SSOLogoutUrl: string;

  constructor(
    private environment: AppConfigService,
    private cryptService: CryptService,
    private paramService: HttpService,
    public translate: TranslateService,
    @Inject(LOCALE_ID) public localeId: string,
    public intlService: IntlService,
    private loginService: LoginService
  ) {
    this.creds = new LoginInputModel();
    this.creds.Username = '';
    this.creds.Password = '';
    this.creds.BusinessUnit = '';
    this.creds.BusinessUnitAName = '';
    this.creds.BusinessUnitName = '';
    this.creds.RememberLogin = '';
    this.creds.ReturnUrl = '';
    this.creds.UserCode = '';
    this.showPassword = false;
    this.Displayedpassword = '';
    this.UserNameErrorMSg = '';
    this.passwordErrorMSg = '';
    this.loginErrorMsgName = '';
  }

  ngOnInit() {
    this.loadLoginParams();

    this.loginService.getCompanyImages().subscribe(res => {
      this.imagePath = `${this.environment.boURL}/CompanyImagesUploads/${res?.value[0].ImagePath}`;
    });
  }

  loadLoginParams() {
    this.loginService.getLoginParams().subscribe(params => {
      params.value.forEach(param => {
        switch (param.PARAM_ID) {
          case SalesBuzzParams.UseSalesBuzzauthentication:
            if (param.PARAM_VALUE == '1') {
              this.AuthTypeItems.push({ text: "SalesBuzz user", value: AuthTypeEnum.SalesBuzz });
            }
            break;
          case SalesBuzzParams.UseActiveDirectoryAuthentication:
            if (param.PARAM_VALUE == '1') {
              this.AuthTypeItems.push({ text: "Active Directory user", value: AuthTypeEnum.ActiveDirectory });
            }
            break;
          case SalesBuzzParams.UseSAML2SSO:
            if (param.PARAM_VALUE == '1') {
              this.AuthTypeItems.push({ text: "SSO SAML 2.0 Authentication", value: AuthTypeEnum.SSO });
            }
            break;
          case SalesBuzzParams.SAMLIDPURLParameter:
            this.SSOLoginUrl = param.PARAM_VALUE;
            break;
          case SalesBuzzParams.SAMLIDPLogoutURLParameter:
            this.SSOLogoutUrl = param.PARAM_VALUE;
            break;
        }
      })

      let defaultAuthenticationMethod = params.value.find(p => p.PARAM_ID == SalesBuzzParams.DefaultAuthenticationMethod);
      let defaultAuthIndex = this.AuthTypeItems.findIndex(item => item.value == Number(defaultAuthenticationMethod?.PARAM_VALUE)) ?? 0;
      this.selectionAuthTypeChange(defaultAuthIndex);
    });
  }

  public selectionAuthTypeChange(value: any): void {
    var index = Number(value);
    this.creds.AuthType = this.AuthTypeItems[index].value;
    this.defaultAuth = this.AuthTypeItems[index];

    if (this.creds.AuthType == AuthTypeEnum.SSO) {
      this.RedirectToSSO();
    }
  }

  RedirectToSSO() {
    if (this.SSOLoginUrl) {
      window.location.href = this.SSOLoginUrl;
    }
  }

  onLoseFocusUsername() {
    this.UserNameErrorMSg = this.creds.Username == '' ? 'FillInUsername' : '';
  }

  onLoseFocusPassword() {
    this.passwordErrorMSg = this.Displayedpassword == '' ? 'FillInPassword' : '';
  }

  async onLoginClick() {
    if (this.creds.Username == '' || this.Displayedpassword == '') {
      this.UserNameErrorMSg = this.creds.Username == '' ? 'FillInUsername' : '';
      this.passwordErrorMSg = this.Displayedpassword == '' ? 'FillInPassword' : '';
      return;
    }
    await this.Login();
  }

  async Login(): Promise<boolean> {
    this.loginErrorMsgName = '';
    if (this.Displayedpassword) {
      var url = `${this.environment.oDataApi}/api/Authenticate/GetUserBusinessUnits?ADAuth=${this.creds.AuthType}`;
      this.creds.Password = this.cryptService.Encrypt(this.Displayedpassword);
      var body = {
        "Password": this.Displayedpassword,
        "Username": this.creds.Username,
      }
      var bussinessUnitList;
      await this.paramService.post(url, body).toPromise().then(res => {
        bussinessUnitList = res;
      },
        err => {
          try {
            this.loginErrorMsgName = err.error.error.message.value;
          }
          catch (ex) {
            this.loginErrorMsgName = 'NetworkError'
          }
        });
      if (this.loginErrorMsgName != '')
        return;
      if (bussinessUnitList?.UserBUPermissions.length != 0) {
        this.listItems = [...bussinessUnitList.UserBUPermissions];
        this.creds.Client = bussinessUnitList.Client;
        this.loginErrorMsgName = '';
        var args = { BUList: this.listItems, creds: this.creds, password: this.Displayedpassword }
        this.LoginEvent.emit(args);
        return true;
      }
      else {
        this.loginErrorMsgName = 'NoAssignedBUIDs';
      }
    }
    return false;

  }

  UpdateCredsLanguage(language) {
    this.creds.Language = language;
  }
}
